export const fadeOut = [
  { offset: 0, opacity: '1' },
  { offset: 1, opacity: '0' }
];
